import { render, staticRenderFns } from "./Catalogo.vue?vue&type=template&id=307d7d10&"
import script from "./Catalogo.vue?vue&type=script&lang=ts&"
export * from "./Catalogo.vue?vue&type=script&lang=ts&"
import style0 from "./Catalogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports